import { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { p, px } from 'styled-components-spacing';

import theme from '@theme';

import { fontButtonLinkDark, fontButtonLinkBright } from './typography';

const { colors, borderRadius, shadows } = theme;

export const linkButtonIcon = css`
  ${fontButtonLinkDark}
  ${p(3.5)}
  ${borderRadius.default}
  ${shadows.default}
  align-items: center;
  background-color: ${colors.white};
  display: flex;
  font-weight: 600;
  justify-content: space-between;
  line-height: 1.4;
  position: relative;
`;

export const linkButtonTransparentBright = css`
  ${theme.borderRadius.default}
  ${p(3.5)}
  ${px(5)}
  ${fontButtonLinkBright}
  border: 1px solid ${colors.white};
  display: inline-block;
  font-weight: 600;

  ${breakpoint('desktop')`
    ${px(6)}
  `}
`;

export const linkButtonAquaMarine = css`
  ${theme.borderRadius.default}
  ${p(3.5)}
  ${px(5)}
  color: ${colors.aquaMarine};
  background-color: transparent;
  border: 1px solid ${colors.aquaMarine};
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
`;

export const linkButtonAquaMarineInverted = css`
  ${linkButtonAquaMarine}
  color: ${colors.white};
  background-color: ${colors.aquaMarine};
  border-color: ${colors.aquaMarine};
`;

export const linkButtonWhite = css`
  ${theme.borderRadius.default}
  ${p(3.5)}
  ${px(5)}
  color: ${colors.white};
  background-color: transparent;
  border: 1px solid ${colors.white};
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
`;

export const HeroSectionGetStarted = css`
  ${linkButtonWhite}
  color: ${colors.white};
  border-color: ${colors.white};
`;
export const linkButtonCurefyInverted = css`
  ${linkButtonAquaMarine}
  color: ${colors.white};
  background-color: ${colors.darkTeal};
  border-color: ${colors.darkTeal};
`;
